import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'wagtailUrl',
    standalone: false
})
export class WagtailUrlPipe implements PipeTransform {
  transform(v?: string): string {
    if (! v || ! v.length) return '/'
    if (v.startsWith("https://")) return v
    return v.replace('//','/')
  }
}
